export enum DataTypes {
  Boolean = 'Boolean',
  String = 'String',
  Object = 'Object',
  Number = 'Number'
}